import { render, staticRenderFns } from "./ElderResidentsByHouseholdRegister.vue?vue&type=template&id=907646aa&"
import script from "./ElderResidentsByHouseholdRegister.vue?vue&type=script&lang=js&"
export * from "./ElderResidentsByHouseholdRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports